import React, { useState } from 'react';
import { Form, useFormikContext } from 'formik';
import { useFormikWizard } from 'formik-wizard';
import { getOtp } from '../../common/constants/api';
// import { Formik, Field, Form, useField } from 'formik';
// import * as Yup from 'yup';
import get from 'lodash/get';
import Error from '../Error/error';
import CommonInput from '../Dashboard-res/CommonComponent/CommonInput';
import { validate as validatePhoneNumber } from '../../components/PhoneNumberValidation/PhoneNumberValidation';
import {
  passwordValidation,
  validationMessage
} from '../PasswordValidation/PasswordValidation';

const RegisterForm = props => {
  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    // setFieldValue,
    isValid,
    dirty,
    initialValues,
    setSubmitting,
    isSubmitting
  } = useFormikContext();
  const { values: wizardValues, setStatus, status } = useFormikWizard();
  const [checked, setChecked] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const inputLength = values.mobile.length;
  const isDirty = initialValues['phone'] !== '' || dirty;
  const isDisabled = !(isValid && isDirty);
  values.disabled ? console.log(values.disabled) : null;
  const handleCheckedChange = e => {
    setChecked(e.target.checked);
  };
  function OpenURL(url) {
    window.open(url);
    window.focus();
  }
  return (
    <div
      autoComplete="off"
      className="flex-1  w-full h-90 md:h-90 max-w-xs mx-auto text-left"
      // onSubmit={handleSubmit}
    >
      {/* {JSON.stringify(values, null, 2)} */}
      <div className="name_field ">
        <div className="grid_input_container mb-4">
          <div>
            <CommonInput
              name="firstName"
              id="firstName"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.firstName}
              stylesContainer={{
                height: '52px',
                maxWidth: '100%'
              }}
              legendName="First Name"
              error={touched.firstName && errors.firstName}
              // errorMsg={errors.firstName}
              touched={touched.firstName}
            />
          </div>
        </div>
      </div>
      <div className="name_field ">
        <div className="grid_input_container mb-4">
          <div>
            <CommonInput
              name="lastName"
              id="lastName"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.lastName}
              stylesContainer={{
                height: '52px',
                maxWidth: '100%'
              }}
              legendName="Last Name"
              error={touched.lastName && errors.lastName}
              // errorMsg={errors.lastName}
              touched={touched.lastName}
            />
          </div>
        </div>
      </div>
      <div className="mobile_field ">
        <div className="grid_input_container relative mb-4">
          <div
            style={{ marginTop: '17px' }}
            className="absolute text-grey-50 z-10 font-normal text-sm pt-px text-md ml-4"
          >
            +91
          </div>
          <div>
            <CommonInput
              name="mobile"
              id="mobile"
              maxLength={10}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.mobile}
              stylesContainer={{
                height: '52px',
                maxWidth: '100%'
              }}
              inputStyle={{
                paddingLeft: '45px',
                letterSpacing: '1px'
              }}
              onBlurStyle={{
                paddingLeft: '20px'
              }}
              legendStyle={{
                paddingLeft: errors.mobile ? '20px' : '20px'
              }}
              legendName="Mobile Number"
              error={touched.mobile && errors.mobile}
              //errorMsg={errors.mobile}
              className={`pt-24`}
              touched={touched.mobile}
              // disabled
              onKeyPress={e => {
                validatePhoneNumber(e, inputLength);
              }}
            />
          </div>
        </div>
      </div>
      <div className="email_field ">
        <div className="grid_input_container mb-4">
          <div>
            <CommonInput
              name="email"
              id="email"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email}
              stylesContainer={{
                height: '52px',
                maxWidth: '100%'
              }}
              legendName="Email ID"
              error={touched.email && errors.email}
              // errorMsg={errors.lastName}
              touched={touched.email}
            />
          </div>
        </div>
      </div>
      <div className="password_field ">
        <div className="grid_input_container mb-4">
          <div>
            <CommonInput
              name="password"
              id="password"
              type="password"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.password}
              onKeyUp={passwordValidation}
              stylesContainer={{
                height: '52px',
                maxWidth: '100%'
              }}
              legendName="Set Password"
              error={touched.password && errors.password}
              // errorMsg={errors.lastName}
              touched={touched.password}
            />
          </div>
        </div>
      </div>
      <div className="inline-flex flex-row p-4 pl-0  mt-1 ">
        <input
          className="mt-1  mr-3 "
          type="checkbox"
          // checked={checked}
          name="terms"
          id="terms"
          value={values.terms}
          onChange={e => handleCheckedChange(e)}
        />
        <div>
          <p className="text-sm block mt-px">
            Legal disclaimer, You agrees to
            <span>
              <a
                className="underline text-teal"
                href="https://fincity-dev-public.s3.ap-south-1.amazonaws.com/TermsAndConditions.pdf"
                target="_blank"
              >
                {' '}
                Terms & Conditions
              </a>
            </span>
          </p>
        </div>
      </div>
      <button
        id="submit"
        className={
          'submitButton w-full capitalize' +
          (isDisabled ? ' bg-grey-700' : ' bg-teal')
        }
        type="submit"
        //disabled={(mobile.length<10)||!checked}
        disabled={isSubmitting || isDisabled || !checked}
      >
        SIGN UP
      </button>
      <div className=" mt-2 block text-red-200 text-center">
        {status?.message}
      </div>
      <div>{validationMessage}</div>
    </div>

    //   )}
    // </Formik>
  );
};

export default RegisterForm;
